module.exports = __webpack_public_path__ + "static/media/69.a21b28a.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/69.wav
// module id = peOK
// module chunks = 0